import { useState } from "react";
import { motion } from "framer-motion";

interface QuestionDreamProps {
  onNext: () => void;
  onBack: () => void;
}

const options = [
  { label: "Dat zou alles veranderen", emoji: "🌟" },
  { label: "Ik zou me zelfverzekerder voelen", emoji: "💪" },
  { label: "Ik zou weer zonder make-up de deur uit durven", emoji: "🌿" },
  { label: "Ik zou me weer mooi voelen", emoji: "🥰" },
];

const QuestionDream = ({ onNext, onBack }: QuestionDreamProps) => {
  const [justSelected, setJustSelected] = useState<number | null>(null);

  const handleSelect = (index: number) => {
    setJustSelected(index);
    setTimeout(() => onNext(), 800);
  };

  return (
    <div>
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-foreground/80 font-sans text-lg md:text-xl mb-5 md:mb-8 hover:text-foreground transition-colors cursor-pointer px-3 py-2 -ml-3 rounded-lg hover:bg-secondary/50"
      >
        <span className="text-xl">←</span> Terug
      </button>

      <div className="text-center">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-2xl md:text-4xl font-serif font-medium text-foreground mb-3 md:mb-4 leading-tight"
        >
          Stel je voor...
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15 }}
          className="text-foreground/80 font-sans text-lg md:text-xl mb-6 md:mb-10 leading-relaxed max-w-md mx-auto"
        >
          Je kijkt over 3 maanden in de spiegel en je huid ziet er weer stralend en stevig uit. Hoe zou dat voelen?
        </motion.p>

        <div className="grid gap-2 md:gap-3">
          {options.map((opt, i) => (
            <motion.button
              key={opt.label}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.25 + 0.07 * i }}
              onClick={() => handleSelect(i)}
              className={`quiz-option text-left flex items-center gap-4 ${
                justSelected === i ? "quiz-option-selected" : ""
              }`}
            >
              <span className="text-2xl flex-shrink-0 w-8 text-center">{opt.emoji}</span>
              <span className="text-foreground font-medium text-lg">{opt.label}</span>
              {justSelected === i && (
                <motion.span
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="ml-auto text-primary font-bold"
                >
                  ✓
                </motion.span>
              )}
            </motion.button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuestionDream;
